import { BehaviorSubject, Observable } from 'rxjs';
import { SETTINGS, EnglishConfig, SpanishConfig } from '../Constants';
import Storage from './Storage';
import {LocaleData} from '../Models/Locales.interface'

// import { Appearance } from 'react-native-appearance';


export interface theme {
    gradient1 : string
    gradient2 : string
    background: string
    secondaryBackground: string
    label : string
    secondaryLabel : string
    drawer1: string
    drawer2: string
}


const themes={
    dark: {
        gradient1: "#06070a",
        gradient2: "#141620",
        background: 'black',
        secondaryBackground: '#333333',
        label: 'white',
        secondaryLabel: 'lightgrey',
        drawer1: '#191e2a',
        drawer2: '#191e2a'
        

    } as theme,
    light: {
        gradient1: "#FDFDFD",
        gradient2: "white",
        background: 'white',
        secondaryBackground: '#EEEEEE',
        label: 'black',
        secondaryLabel: '#222222',
        drawer1: '#fdfdfd',
        drawer2: '#dfdfdf'
    } as theme
}

export type SettingsData = {
    language: string,
    locale: LocaleData,
    biometrics: boolean,
    theme: theme,
}

export const defaultSettings = (): SettingsData  => {
  return{
    language: 'en',
    locale: EnglishConfig,
    biometrics: false,
    theme: themes.dark
  }
}

export class SettingsManagement {

    data: SettingsData = defaultSettings()
    settings = new BehaviorSubject(defaultSettings())

    constructor(){  
        Storage.get(SETTINGS)
            .then(d => {
                const { locale, theme, ...rest} = defaultSettings()
                let data = {                    
                    ...rest,
                    ...d,
                    locale,
                    theme
                    
                }
                 this.settings.next(data)
            })
            .catch(console.log)
    }

    updateColorScheme = (theme: string) => {
        
        let data = {...this.settings.getValue(), theme: themes[theme] || themes.light}
        this.save(data)
    }
    
    setLanguage = (language: string) => {
        let data = {...this.settings.getValue(), language: language}
        data.locale = language === 'en' || language === "asl" ? EnglishConfig : SpanishConfig
        this.save(data)
    }
    toggleLanguage = () => {
        let lan = this.settings.getValue().language === 'es' ? 'en' : 'es'
        this.setLanguage(lan)
    }

    save = (data: SettingsData) => {
        this.settings.next(data)
        Storage.set(SETTINGS, data)
    }
    
    get = ():Observable<SettingsData> => this.settings.asObservable()

    
}

const Settings = new SettingsManagement()
export default Settings





